import * as React from 'react'
import { ApiContext, ApiContextInterface } from 'providers/api'

export default function useApi(): ApiContextInterface | any {
    return React.useContext(ApiContext)
}
